<template>
<center>
    <div class="card card-body agatrs-card-style">
        <div class="col-md-12">
            <Header :pageTitle="pageTitle" class="card-container"></Header>
            <div class="row">
                <div class="col-md-3">
                    <label>Country</label>
                    <v-select v-model="financeOffice['countryId']" name="CountryDropdown" :reduce="item => item.countryId" label="name" :options="countriesOptions" placeholder="Please select a country."></v-select>

                </div>
                <div class="col-md-3">
                    <label>Name</label>
                    <base-input v-model="financeOffice['name']" name="Name" placeholder="Please enter a name."></base-input>
                </div>
                <div class="col-md-3">
                    <label>Email</label>
                    <base-input v-model="financeOffice['email']" name="Email" placeholder="Please enter an email."></base-input>
                </div>
                <div class="col-md-3">
                    <label>Address</label>
                    <base-input v-model="financeOffice['address']" name="Address" placeholder="Please enter an address."></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-3 offset-md-3">
                    <label>DSN Phone Number</label>
                    <base-input v-model="financeOffice['dsnPhoneNumber']" name="DsnPhoneNumber" placeholder="Please enter a DSN phone number."></base-input>
                </div>
                <div class="col-md-3">
                    <label>Commercial Phone Number</label>
                    <base-input v-model="financeOffice['commercialPhoneNumber']" name="CommercialPhoneNumber" placeholder="Please enter a commercial phone number."></base-input>
                </div>
            </div>
            <div class="row">
                <div class="col-md-2 align-left">
                    <base-button @click="returnToEditFinanceOfficesDashboard()" class="btn btn-dark" v-b-popover.hover.bottom="'Navigate back to edit finance offices dashboard.'">
                        <i class="tim-icons icon-double-left"></i> Back
                    </base-button>
                </div>
                <div class="col-md-2 offset-md-3 align-left">
                    <base-button @click="saveFinanceOffice()" type="primary" v-b-popover.hover.bottom="'Save changes.'">
                        <i class="tim-icons icon-bank"></i> Save Changes
                    </base-button>
                </div>
            </div>
        </div>
    </div>
</center>
</template>

<script>
import Header from "@/components/App/Header.vue";
import axios from "@/axios";
import {
    mapGetters,
    mapActions
} from "vuex";

export default {
    name: 'EditFinanceOffice',
    components: {
        Header
    },
    data() {
        return {
            financeOffice: []
        };
    },
    computed: {
        ...mapGetters({
            countriesOptions: 'countries/allCountries',
        }),
        pageTitle() {
            return `Edit Finance Office #${this.$route.params.id}`
        },
    },
    mounted() {
        this.getFinanceOffice()
        this.getAllCountries()
    },
    methods: {
        ...mapActions({
            getAllCountries: 'countries/getAllCountries'
        }),
        returnToEditFinanceOfficesDashboard() {
            this.$router.push('/Admin/FinanceOffices')
        },
        getFinanceOffice() {
            axios
                .get(`api/financialoffices/${this.$route.params.id}`)
                .then((response) => {
                    this.financeOffice = response.data
                });
        },
        saveFinanceOffice() {
            axios
                .post("api/financialoffices", this.financeOffice)
                .then((response) => {
                    this.getFinanceOffice()
                });
        }
    }
};
</script>

<style>
</style>
